import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader';

export default {
    methods: {
        initRenderer() {
            this.renderer = new THREE.WebGLRenderer({
                antialias: true,
                alpha: true,
                preserveDrawingBuffer: true
            });
            this.renderer.setPixelRatio(window.devicePixelRatio);
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            this.renderer.shadowMap.enabled = true;
            this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
            this.$refs.renderer.appendChild(this.renderer.domElement);
        },

        initScene() {
            this.scene = new THREE.Scene();
            this.scene.background = new THREE.Color(0xf0f0f0);
            this.scene.fog = new THREE.Fog(0xf0f0f0, 10, 50);
        },

        initCamera() {
            this.camera = new THREE.PerspectiveCamera(
                45,
                window.innerWidth / window.innerHeight,
                0.1,
                1000
            );
            this.camera.position.set(0, 0, 5);
            this.camera.lookAt(0, 0, 0);
        },

        initControls() {
            this.controls = new OrbitControls(this.camera, this.renderer.domElement);
            this.controls.enableDamping = true;
            this.controls.dampingFactor = 0.05;
            this.controls.screenSpacePanning = false;
            this.controls.minDistance = 1;
            this.controls.maxDistance = 20;
            this.controls.maxPolarAngle = Math.PI;
        },

        initComposer() {
            this.composer = new EffectComposer(this.renderer);
            this.renderPass = new RenderPass(this.scene, this.camera);
            this.composer.addPass(this.renderPass);

            this.outlinePass = new OutlinePass(
                new THREE.Vector2(window.innerWidth, window.innerHeight),
                this.scene,
                this.camera
            );
            this.outlinePass.visibleEdgeColor.set('#ffffff');
            this.outlinePass.hiddenEdgeColor.set('#190a05');
            this.outlinePass.edgeStrength = 3.0;
            this.outlinePass.edgeGlow = 0.0;
            this.outlinePass.edgeThickness = 1.0;
            this.composer.addPass(this.outlinePass);

            const effectFXAA = new ShaderPass(FXAAShader);
            effectFXAA.uniforms['resolution'].value.set(
                1 / window.innerWidth,
                1 / window.innerHeight
            );
            this.composer.addPass(effectFXAA);
        },

        onWindowResize() {
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            this.composer.setSize(window.innerWidth, window.innerHeight);
        },

        animate() {
            requestAnimationFrame(this.animate);
            this.controls.update();
            this.composer.render();
        }
    }
}
